import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { GrooveCalloutDirective } from '@groove/angular';

export type CalloutVariant = 'info' | 'warning';

@Component({
  selector: 'app-callout',
  imports: [GrooveCalloutDirective],
  templateUrl: './callout.component.html',
  styleUrl: './callout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalloutComponent {
  readonly heading = input.required<string>();
  readonly variant = input<CalloutVariant>('info');
}
